import Rollbar from 'rollbar';

module?.hot?.accept(); // Enable HMR if module.hot is available.

window.ErrorReporter = {
    ...console,
    ...{
        warning: (...args) => console.warn.apply(console, args),
        critical: (...args) => console.error.apply(console, args),
    },
};

if (ENVConfig.rollbar?.accessToken) {
    window.ErrorReporter = new Rollbar({
        captureUncaught: true,
        captureUnhandledRejections: true,
        ...ENVConfig.rollbar,
    });
    window.ErrorReporter.warn = (...args) =>
        window.ErrorReporter.warning(...args);
    window.ErrorReporter.trace = (...args) =>
        window.ErrorReporter.critical(...args);
}

import('./application');
